'use strict';

module.exports = function (h, that) {

  var sortControl = require('./sort-control')(h, that);
  var headings = [];
  var colIndex = -1;

  if (that.hasChildRow && that.opts.childRowTogglerFirst) headings.push(h('th'));

  that.allColumns.map(function (column) {
    colIndex += 1;
    if (that.opts.tooltip !== undefined && that.opts.tooltip[column] !== undefined) {
      headings.push(h(
        'th',
        {
          attrs: {
            draggable: that.opts.draggable
          },
          on: {
            'dragstart': that.ondragstart.bind(that, column),
            'dragenter': that.ondragover.bind(that, column),
            'click': that.orderByColumn.bind(that, column)
          },


          ref: 'HC' + colIndex,
          'class': that.sortableClass(column)
        },
        [h(
          'span',
          {
            directives: [{
              name: 'tooltip',
              value: that.opts.tooltip[column]
            }],

            'class': 'VueTables__heading', attrs: { title: that.getHeadingTooltip(column, h) }
          },
          [that.getHeading(column, h)]
        ), sortControl(column)]
      ));
    } else {
      headings.push(h(
        'th',
        {
          attrs: {
            draggable: that.opts.draggable
          },
          on: {
            'dragstart': that.ondragstart.bind(that, column),
            'dragenter': that.ondragover.bind(that, column),
            'click': that.orderByColumn.bind(that, column)
          },

          ref: 'HC' + colIndex,
          'class': that.sortableClass(column)
        },
        [h(
          'span',
          {
            'class': 'VueTables__heading',
            attrs: { title: that.getHeadingTooltip(column, h)
            }
          },
          [that.getHeading(column, h)]
        ), sortControl(column)]
      ));
    }
  }.bind(that));

  if (that.hasChildRow && !that.opts.childRowTogglerFirst) headings.push(h('th'));

  return headings;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/template/headings.js